<template>
  <div>
    <div id="schlagwoerter-outer">
      <div id="schlagwoerter-sequence">
        <SchlagwortComponent :schlagwort="firstSchlagwort.text" v-bind:is-last-schalgwort="false"
                             :type="firstSchlagwort.type"/>
        <template v-for="schlagwort in middleSchlagworts">
          <SchlagwortComponent :key="schlagwort.text" :schlagwort="schlagwort.text" v-bind:is-last-schalgwort="false"
                               :type="schlagwort.type"/>
        </template>
        <SchlagwortComponent v-if="this.lastSchlagwort" :schlagwort="this.lastSchlagwort"
                             v-bind:is-last-schalgwort="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import SchlagwortComponent from "./SchlagwortComponent";

export default {
  name: "SchlagwoerterComponent",
  components: {SchlagwortComponent},
  props: {
    rowsUsed: Array,
    activeRow: Object
  },
  computed: {
    firstSchlagwort() {
      if (this.rowsUsed.length > 1) {
        return {text: this.rowsUsed[1]["Brotkrumen_Text"], type: "answer"}
      } else {
        return {text: this.activeRow["KurzFrage"], type: "question"}
      }
    },
    middleSchlagworts() {
      if (this.rowsUsed.length < 2) {
        return []
      } else {
        const result = this.rowsUsed.slice(2, this.rowsUsed.length).map(i => {
            return {text: i["Brotkrumen_Text"], type: "answer"}
        })
        if (!this.activeRow) {
          return result
        } else {
          result.push({text: this.activeRow["KurzFrage"], type: "question"})
          return result
        }
      }
    },
    lastSchlagwort() {
      if (this.activeRow) {
        return null
      } else {
        return "Anfallstyp bestätigen"
      }
    }
  }
}
</script>

<style scoped>


#schlagwoerter-outer {
  display: grid;
  grid-template-areas:
      "sequence info";
  grid-template-rows: 1fr;
  grid-template-columns: 1fr min-content;
}

#schlagwoerter-sequence {
  grid-area: sequence;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-row-gap: 30px;
  height: 100%;
}

#schlagwoerter-info {
  grid-area: info;
}
</style>